export type TokenConfig = {
  address: string;
  name?: string;
  symbol?: string;
  imageUri?: string;
  resourceId: string;
  isNativeWrappedToken?: boolean;
};

export type TokenConfig1155 = TokenConfig & {
  tokenIds: Array<number>;
};

export type BridgeConfig = {
  chainId: number;
  networkId: number;
  name: string;
  bridgeAddress: string;
  erc20HandlerAddress: string;
  rpcUrl: string;
  type: "Ethereum" | "Substrate";
  tokens: TokenConfig[];
  erc721Tokens: TokenConfig[];
  erc721HandlerAddress: string;
  erc1155Tokens: TokenConfig1155[];
  erc1155HandlerAddress: string;
  nativeTokenSymbol: string;
  //This should be the full path to display a tx hash, without the trailing slash, ie. https://etherscan.io/tx
  blockExplorer?: string;
  defaultGasPrice?: number;
  deployedBlockNumber?: number;
};

export type ChainbridgeConfig = {
  palmNetwork: number;
  chains: BridgeConfig[];
  ipfsGateway?: string;
};

import _config from "./config/config.json";
export const chainbridgeConfig: ChainbridgeConfig =
  _config as ChainbridgeConfig;

export function isPalmNetwork(networkId: number): boolean {
  return chainbridgeConfig.chains[1].networkId === networkId;
}

export function getPalmNetworkId(): number {
  return chainbridgeConfig.chains[1].networkId;
}

export function networkIds(): number[] {
  return chainbridgeConfig.chains.map((config) => {
    return config.networkId;
  });
}

export function lookupToken(
  networkId: number,
  symbol: string
): TokenConfig | undefined {
  const chain: BridgeConfig | undefined = chainbridgeConfig.chains.find(
    (config) => {
      return config.networkId === networkId;
    }
  );
  if (chain) {
    return chain.tokens.find((token) => {
      return token.symbol === symbol;
    });
  }
  throw "Could not lookup token";
}

export function networkNameByNetworkId(networkId: number): string {
  return (
    chainbridgeConfig.chains.find((chain) => chain.networkId === networkId)
      ?.name || "Unsupported"
  );
}
